import getStartOfDay from './get-start-of-day';

export { getStartOfDay };

export default getStartOfDay;
